import { createUSeDirectBookingStrategy } from "./usedirect.js";

const strategy = createUSeDirectBookingStrategy({
  bookingBaseUrl: "https://reservemn.usedirect.com/MinnesotaWeb",
});

export default {
  ...strategy,
  buildPreviewUrl(site, facility) {
    // Finland's bookable group site belongs to the forest but is hosted under
    // Tettegouche's provider PlaceId. Its facility URL is the useful preview.
    if (facility?.name === "Finland State Forest") return site.reserveUrl;
    return strategy.buildPreviewUrl(site, facility);
  },
};
